export default __webpack_public_path__ + "static/media/unbraked-demo.7a5190d8.png";